// extracted by mini-css-extract-plugin
export var arrow = "SectionsContainer-module--arrow--aae1a";
export var arrowNo = "SectionsContainer-module--arrow_no--eafd5";
export var arrowYes = "SectionsContainer-module--arrow_yes--b0504";
export var articleTemplate = "SectionsContainer-module--articleTemplate--ab12d";
export var documentTemplate = "SectionsContainer-module--documentTemplate--37bf9";
export var flex = "SectionsContainer-module--flex--40547";
export var flex1 = "SectionsContainer-module--flex_1--eed8e";
export var flexCenter = "SectionsContainer-module--flex_center--df1a8";
export var flexCenterCol = "SectionsContainer-module--flex_center_col--1e3b6";
export var flexCol = "SectionsContainer-module--flex_col--f19f6";
export var flexFixCenterCol = "SectionsContainer-module--flex_fix_center_col--f1e5f";
export var flexFixedCenterCol = "SectionsContainer-module--flex_fixed_center_col--ad2bf";
export var hasOpenOverlay = "SectionsContainer-module--hasOpenOverlay--76a7f";
export var rotating = "SectionsContainer-module--rotating--f03d1";
export var sectionsContainer = "SectionsContainer-module--sectionsContainer--b8479";
export var userCollectionTemplate = "SectionsContainer-module--userCollectionTemplate--55461";